import React, { useRef } from "react";
import SignatureCanvas from "react-signature-canvas";
import ReplayOutlinedIcon from '@mui/icons-material/ReplayOutlined';
import axiosInstance from "../../api/axiosInstance";
import moment from 'moment';
import "./signModal.scss"


const Sign = ({ event, setSign, fetchData }) => {
    const sigCanvas = useRef(null);

    const clearSignature = () => {
        sigCanvas.current.clear();
    };

    const saveSignature = async () => {
        if (sigCanvas.current.isEmpty()) {
            alert("Bitte eine Unterschrift zeichnen!");
            return;
        }

        const dataURL = sigCanvas.current.toDataURL("image/png");

        try {
            if (event.id) {
                await axiosInstance.put(`operators/signature/${event.id}`, {
                    signature: dataURL
                });

                await fetchData();
                setSign(false);
            }
        } catch (err) {
            console.error("Fehler beim Ändern des Ereignisses:", err);
            alert("Fehler beim Speichern der Unterschrift.");
        }
    };

    return (
        <div className="signModal">
            <div className="content">
                <div className="group">
                    <div className="title">
                        <span>Auftragspositionen</span>
                    </div>
                    <div className="data">
                        <div className="item">
                            <label>01</label>
                            <span>{event.itemAlias}</span>
                        </div>
                    </div>
                </div>
                <div className="group">
                    <div className="title">
                        <span>Unterschrift</span>
                    </div>
                    <div className="signature">
                        <div className="signatureData">
                            <span>{moment(event.signedAt ?? Date.now()).format("DD.MM.YYYY, HH:mm ")} Uhr</span>
                        </div>
                        {event.done === 1
                            ? <img src={event.signature} className="sigImage" alt="Unterschrift" />
                            : <SignatureCanvas
                                ref={sigCanvas}
                                penColor="black"
                                canvasProps={{ className: "sigCanvas" }}
                            />
                        }
                        <div className="signatureControls">
                            {event.done === 0 && <button onClick={clearSignature} className="secondary">
                                <ReplayOutlinedIcon />
                            </button>}
                            {event.done === 0 && <button onClick={saveSignature}>Absenden</button>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Sign